const BOOK_BUILDER_URL = 'https://anekdamian-character-creator.vercel.app';
const CARD_BUILDER_URL = 'https://anekdamian-card-builder.vercel.app';
const PLAYMAT_BUILDER_URL = 'https://anekdamian-playmat-customizer.vercel.app';

export { BOOK_BUILDER_URL, CARD_BUILDER_URL, PLAYMAT_BUILDER_URL };
